<style lang="sass" scoped>
.coupon
    .p-main
        padding: 20px 20px 0
    .cp-tabs
        text-align: left
        .cp-tab
            float: left
            width: 100px
            height: 30px
            line-height: 28px
            background: #fff
            border: 1px solid #e9e9e9
            border-bottom: none
            border-radius: 4px 4px 0 0
            margin-right: 20px
            cursor: pointer
            text-align: center
            &.cur
                border: none
                background: linear-gradient(315deg,rgba(250,234,97,1) 0%,rgba(255,184,31,1) 100%)
                border-radius: 4px 4px 0px 0px
                span
                    color: #282729
            span
                color: #999
    .fr
        cursor: pointer
        span
            display: inline-block
            margin-left: 10px
            width: 130px
            height: 24px
            line-height: 24px
            text-align: center
            color: #fff
            font-size: 12px
            background: #FF3973
            border-radius: 4px
    .cp-main
        padding: 20px
        background: #fff
        border: 1px solid #e9e9e9
        height: calc(100% - 30px)
        position: relative
        overflow: hidden
        &:hover
            overflow: auto
        .cp-ctn
            // padding: 20px
            // overflow: auto
            min-width: 920px
        .cp-item
            width: calc(50% - 10px)
            min-width: 450px
            height: 100px
            float: left
            // border: 1px solid #e9e9e9
            border-radius: 7px
            margin-bottom: 20px
            padding: 20px 0
            cursor: pointer
            position: relative
            overflow: hidden
            box-shadow: 0px 0px 10px 2px rgba(0,0,0,0.1)
            &:nth-of-type(2n)
                float: right
            &.choose
                border: 2px solid #FF3973
                .cp-dtl
                    width: calc(100% - 140px)
                .icon-buzhoutiao1
                    display: block
            &.disable
                cursor: not-allowed
                .cp-dtl
                    line-height: 20px
                    &.no-reason
                        line-height: 30px
                .fee, .cp-dtl
                    color: #999

            .icon-buzhoutiao1
                position: absolute
                right: 10px
                font-size: 18px
                margin-top: 20px
                color: #FF3973
                display: none

            .will-end
                width: 80px
                position: absolute
                right: 0
                top: 0

            .fee
                float: left
                width: 120px
                height: 60px
                border-right: 1px solid #e9e9e9
                text-align: center
                font-size: 28px
                font-weight: bold
                color: #FF3973
                line-height: 60px
                &.has-type
                    line-height: 40px
                span
                    font-size: 20px
                i
                    font-size: 12px
                    color: #999
                    display: block
                    line-height: 1.2
                    font-style: normal
                    font-weight: 400
            
            .cp-dtl
                display: inline-block
                width: calc(100% - 120px)
                padding: 0 20px
                line-height: 30px
                font-size: 16px
                font-weight: 600
                float: left
                &.no-btn
                    .cp-dtl-main
                        width: 100%
                .cp-dtl-main
                    display: inline-block
                    width: calc(100% - 130px)
                .els
                    // width: calc(100% - 130px)
                    width: 100%
                .time
                    font-size: 14px
                    font-weight: 400
                    color: #999
                .reason
                    font-weight: 600
                    color: #282729
                    font-size: 14px

            .user-btn
                width: 112px
                height: 30px
                line-height: 30px
                border-radius: 30px
                border: 1px solid #e9e9e9
                text-align: center
                margin-top: 15px

            .cp-btn
                width: 120px
                height: 30px
                border-radius: 15px
                line-height: 28px
                margin-top: 15px
                font-weight: bold
                font-size: 14px
                color: #FF3973
                padding: 0 20px
                cursor: pointer
                border: 1px solid #FF3973
                img
                    float: right
                    width: 16px
                    height: 16px
                    margin-top: 6px
                    position: relative
                    left: 5px

.no-dist
    text-align: center
    line-height: 30px
    img
        width: 120px
</style>

<template lang="pug">
    .coupon
        .p-title 优惠券
        .p-main
            .cp-tabs
                .cp-tab(
                    v-for="(item, i) in ['可用', '已使用', '已失效']"
                    @click.stop="cpTab=i"
                    :class="{'cur':cpTab==i}"
                ) {{item}}
                    span ({{cpNum(i)}})
                    //- span ({{i==0 ? coupons.filter(el=>el.choose).length : coupons.filter(el=>!el.choose).length}}个)
                    //- span {{curCouponList}}
                .clear
            .cp-main
                .cp-ctn
                    .cp-item(v-for="(item, i) in curCouponList" :key="i" :class="{'disable': cpTab != 0}")
                        //- @click="curChooseCpIdx=i" :class="{'choose':curChooseCpIdx==i}"
                        //- img.will-end(src="../assets/willEnd.png" v-if="cpTab==0 && isWillEnd(item)")
                        img.will-end(src="../assets/willEnd.png" v-if="cpTab==0 && item.almostExpired")
                        i.iconfont.icon-buzhoutiao1(v-if="cpTab==0")
                        .fee.Akrobat-ExtraBold(:class="{'has-type':item.limitName}")
                            span ￥
                            | {{item.amount}}
                            i.els {{item.limitName}}
                        .cp-dtl(:class="{'no-btn':cpTab==2, 'no-reason':cpTab!=2}")
                            .cp-dtl-main
                                .els 
                                    span(v-if="item.couponType") [{{item.couponType}}]&nbsp;
                                    span(:title="item.couponName") {{item.couponName}}
                                .els.time {{item.startTime | date(".") }} - {{item.endTime | date(".") }}
                                .els.reason(v-if="cpTab==2") {{item.reason}}

                            .user-btn.fr(v-if="cpTab==1") 已使用
                            .cp-btn.fr(v-if="cpTab==0" @click="goUrl('/putOrderMap')") 立即使用
                                img(src="../assets/home-arrow.png")
                    .clear

                .no-dist.center-center(v-show="curCouponList.length == 0")
                    img.no(src="../assets/no-dist.png")
                    div 暂无记录
                        
</template>

<script>
export default {
    name: 'coupon',
    data(){
        let tdTime = new Date().setHours(0,0,0,0)
        return {
            tdTime,
            cpTab: 0,
            // curChooseCpIdx: -1
        }
    },
    created(){
        this.$store.dispatch('coupon/getAllCoupon')
    },
    computed: {
        isWillEnd(){
            return item => {
                if(!item.endTime) return false 
                return new Date(item.endTime).setHours(0,0,0,0) - this.tdTime <= 3*24*60*60*1000
            }
        },
        okCps(){
            return this.storeGet('coupon/okCoupons')
            // .sort( (a, b) => b.amount - a.amount)
        },
        usedCps(){
            return this.storeGet('coupon/usedCoupons')
        },
        disCps(){
            return this.storeGet('coupon/disabledCoupons')
        },
        curCouponList(){
            return this.cpTab == 0 ? this.okCps : this.cpTab == 1 ? this.usedCps : this.cpTab == 2 ? this.disCps : []
        },
        cpNum(){
            return idx => {
                let num = idx == 0 ? this.okCps.length : idx == 1 ? this.usedCps.length : idx == 2 ? this.disCps.length : 0
                return num > 99 ? '99+' : num
            }
        }
    }
}
</script>

